/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientTeamRole } from './';
import {
    ClientTeamRoleFromJSON,
    ClientTeamRoleFromJSONTyped,
    ClientTeamRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyInvitationResource
 */
export interface ClientCompanyInvitationResource {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyInvitationResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyInvitationResource
     */
    email: string;
    /**
     * 
     * @type {ClientTeamRole}
     * @memberof ClientCompanyInvitationResource
     */
    role: ClientTeamRole;
    /**
     * 
     * @type {Date}
     * @memberof ClientCompanyInvitationResource
     */
    lastSend: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClientCompanyInvitationResource
     */
    expirationDate: Date;
}

/**
 * Check if a given object implements the ClientCompanyInvitationResource interface.
 */
export function instanceOfClientCompanyInvitationResource(value: object): value is ClientCompanyInvitationResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('lastSend' in value) || value['lastSend'] === undefined) return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined) return false;
    return true;
}

export function ClientCompanyInvitationResourceFromJSON(json: any): ClientCompanyInvitationResource {
    return ClientCompanyInvitationResourceFromJSONTyped(json, false);
}

export function ClientCompanyInvitationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyInvitationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'role': ClientTeamRoleFromJSON(json['role']),
        'lastSend': (new Date(json['lastSend'])),
        'expirationDate': (new Date(json['expirationDate'])),
    };
}

export function ClientCompanyInvitationResourceToJSON(value?: ClientCompanyInvitationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'role': ClientTeamRoleToJSON(value['role']),
        'lastSend': ((value['lastSend']).toISOString().substring(0,10)),
        'expirationDate': ((value['expirationDate']).toISOString().substring(0,10)),
    };
}

